import { render, staticRenderFns } from "./ButtonAlternates.vue?vue&type=template&id=500906bb&"
import script from "./ButtonAlternates.vue?vue&type=script&lang=js&"
export * from "./ButtonAlternates.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAlternates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500906bb')) {
      api.createRecord('500906bb', component.options)
    } else {
      api.reload('500906bb', component.options)
    }
    module.hot.accept("./ButtonAlternates.vue?vue&type=template&id=500906bb&", function () {
      api.rerender('500906bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ButtonAlternates.vue"
export default component.exports